const cartQuantity = (products) => {
    document.querySelectorAll('.js-thumb.is-in-cart').forEach(thumb => {
        thumb.classList.remove('is-in-cart')
    })

    if (!products) {
        return
    }

    for (const productId in products) {
        const product = products[productId]

        if (product.quantity == 0) {
            return
        }

        document.querySelectorAll(`.js-thumb[data-product-id="${product.id}"]`).forEach(thumb => {
            thumb.classList.add('is-in-cart')
        })
    }
}

rEvent.on('Cart.product.after_add', function (response) {
    if (!response || !response.status) {
        return
    }

    cartQuantity(response.products)
})

rEvent.on('Cart.product.removed', function (data) {
    if (!data || !data.response || !data.response.status) {
        return
    }

    cartQuantity(data.response.products)
})

rEvent.on('Cart.fetchedProducts', function (data) {
    if (!data) {
        return
    }

    const response = data.response

    if (!response || !response.status || !response.data) {
        return
    }

    cartQuantity(response.data.items)
})

rEvent.on('Cart.product.before_add', function (form) {
    const button = form.querySelector('[type="submit"]')

    if (button.removeClassTimeout) {
        clearTimeout(button.removeClassTimeout)
    }

    button.classList.remove('is-loaded')
    button.classList.remove('has-error')
    button.classList.add('is-loading')
    button.disabled = true
})

rEvent.on('Cart.product.after_add', function (response) {
    if (!response || !response.status) {
        return
    }
})

rEvent.on('Custom.Cart.addedItem', function (data) {
    const { form, response } = data

    const button = form.querySelector('[type="submit"]')

    if (!response.status) {
        button.classList.add('has-error')
    }

    button.classList.add('is-loaded')
    button.classList.remove('is-loading')
    button.disabled = false

    button.removeClassTimeout = setTimeout(() => {
        button.classList.remove('is-loaded')
        button.removeClassTimeout = false
    }, 1000)
})

Cart.callbacks.addedItem = function (form, response) {
    if (!response.status) {
        Eshop.tippyAlert(form.querySelector('.products__buy') || form, response.message, {
            theme: 'error'
        });
        Eshop.preloader.hide();

        Cart.customCallbacks.addedItem(form, response);

        return;
    }

    var $product = $('.cart__product[data-id="' + response.item.id + '"]');

    $('.cart').replaceWith(response.cart);

    if (response.upsell.active && !$('#up-sell').is(':visible')) {
        $.get(response.upsell.url, {
            quantity: response.item.added_quantity
        }, function (html) {
            $('#up-sell').remove();
            $('body').append(html);
            $('#up-sell').modal();
            Eshop.preloader.hide();
            rEvent.dispatch('Cart.upsell.show');
        }, 'html');
    } else {
        Eshop.tippyAlert(form.querySelector('.products__buy') || form, response.message, {
            theme: 'success'
        });
        Eshop.preloader.hide();
    }

    if (response.item) {
        Cart.updates.product($product, response.item);
    }

    if (response.totals) {
        Cart.updates.totals(response.totals);
    }

    if (response.free_shipping) {
        Cart.updates.freeShipping(response.free_shipping);
    }

    if (typeof RshopApp !== 'undefined' && RshopApp._isMounted) {
        store.dispatch('fetchCart');
    }

    Cart.storeItems();
    Cart.customCallbacks.addedItem(form, response);
}
